// `tailwind-base.config.js` is CommonJS (it is also loaded by tailwind.config.js,
// which Tailwind 3.1 requires to be CommonJS). Vite converts it to ESM via the
// `optimizeDeps.include` entry in vite.config.mts; webpack handles it natively.
import tailwindBaseConfig from '@evidentid/style-configs/tailwind-base.config';

export const tailwindColors: Record<string, Record<string, string>> =
    tailwindBaseConfig.theme.extend.colors;
